<template>
  <div>
    <el-dialog
      v-if="show"
      :visible.sync="show"
      :show-close="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :append-to-body="appendToBody"
      :width="width"
      custom-class="normal-dialog common-confirm-dialog"
      class="touch-confirm-dialog"
    >
      <div class="common-confirm-dialog-template" :class="{'is-triage': isTriageDesk}">
        <div v-if="showHeader" class="dialog-header">
          <div v-if="showClose" class="close-icon-container" @click="closeHandler">
            <i class="iconfont icon-close" />
          </div>
        </div>
        <div class="dialog-body">
          <div v-if="img" :class="`img ${img}`" />
          <div v-if="title" class="title font-semibold" :class="{'custom-title': customTitle}">
            {{ title }}
          </div>
          <div class="dialog-content-container">
            <slot name="content">
              <div v-if="content" class="content font-medium" :class="{'is-triage-content': isTriageDesk}" v-html="content" />
              <slot name="content-bottom" />
            </slot>
          </div>
        </div>
        <template v-if="isTriageDesk">
          <div v-if="showMainBtn || showSubBtn" class="dialog-footer is-triage-footer" :class="{'custom-footer': customFooter}">
            <el-button v-if="subBtnText || showSubBtn" class="btn-yellow back-btn triage-btn" @click="subBtnClickHandler">
              {{ subBtnText }}
            </el-button>
            <el-button v-if="mainBtnText || showMainBtn" class="btn-yellow triage-btn" @click="mainBtnClickHandler">
              {{ mainBtnText }}
            </el-button>
          </div>
        </template>
        <template v-else>
          <div v-if="showMainBtn || showSubBtn" class="dialog-footer" :class="{'custom-footer': customFooter}">
            <el-button v-if="subBtnText || showSubBtn" class="button button-normal button-default" @click="subBtnClickHandler">
              {{ subBtnText }}
            </el-button>
            <el-button v-if="mainBtnText || showMainBtn" class="button button-normal" @click="mainBtnClickHandler">
              {{ mainBtnText }}
            </el-button>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    width: {
      default: '440px',
      type: String,
    },
    img: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    content: {
      default: '',
      type: String,
    },
    mainBtnText: {
      default: '',
      type: String,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    showMainBtn: {
      default: true,
      type: Boolean,
    },
    subBtnText: {
      default: '',
      type: String,
    },
    showSubBtn: {
      default: false,
      type: Boolean,
    },
    showClose: {
      default: true,
      type: Boolean,
    },
    appendToBody: {
      default: false,
      type: Boolean,
    },
    // 自定义标题样式
    customTitle: {
      default: false,
      type: Boolean,
    },
    customFooter: {
      default: false,
      type: Boolean,
    },
    isTriageDesk: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    mainBtnClickHandler() {
      this.$emit('mainBtnClick');
      this.closeHandler();
    },
    subBtnClickHandler() {
      this.$emit('subBtnClick');
      this.closeHandler();
    },
    closeHandler() {
      this.$emit('update:show', false);
    },
  },
}
</script>

<style lang="scss" scoped>
.common-confirm-dialog {
  .common-confirm-dialog-template {
    padding: 20px 0 24px;
    word-break: normal;
    &.is-triage {
      padding: 34px 12px 40px;
    }
  }

  .dialog-header {
    position: relative;
    height: 44px;

    .close-icon-container {
      position: absolute;
      right: -8px;
      padding: 4px 0;
      width: 32px;
      height: 32px;
      text-align: center;
      background: #f3f6fa;
      border-radius: 50%;
      z-index: 999;
      cursor: pointer;

      .iconfont {
        color: var(--txt-color-lv2);
        font-size: 14px;
        font-weight: bold;
        line-height: 24px;
      }

      &:hover .iconfont {
        color: var(--txt-color-lv1);
        background: #f6f6f6;
      }
    }
  }

  .dialog-body {
    .img {
      background-size: 100% 100%;
      margin: 0 auto;
      width: 225px;
      height: 225px;

      &.box {
        background: url('~assets/images/error/unpaid_box.png') no-repeat;
        background-size: 100% 100%;
        margin: -53px auto 10px;
        width: 112px;
        height: 112px;
      }
    }

    .title {
      margin: 0 auto;
      width: 360px;
      text-align: center;
      font-size: 20px;
      line-height: 24px;
      color: var(--txt-color-lv1);

      &:nth-child(1) {
        margin-top: 24px;
      }
    }

    .title.custom-title {
      margin-top: 0;
    }

    .dialog-content-container {
      .content {
        margin: 10px auto;
        width: 360px;
        text-align: center;
        font-size: 16px;
        line-height: 19px;
        color: var(--txt-color-lv2);
        &.is-triage-content {
          width: 100%;
          font-size: 20px;
          font-family: Roboto-Flex, sans-serif;
          font-weight: 600;
          color: #44454C;
          line-height: 28px;
          text-align: left;
          margin: 0;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    margin: 44px auto 24px;
    min-height: 10px;

    .button {
      width: 100%;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
    &.is-triage-footer {
      margin: 34px 0 0;
      justify-content: space-between;
    }
  }

  .custom-footer {
    margin: 32px 0 0 0;
  }
  .triage-btn {
    width: 200px;
    height: 58px;
    font-size: 20px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: 600;
  }
}
@media (max-width: 768px) {
  ::v-deep .touch-confirm-dialog .common-confirm-dialog {
    width: 91.46667vw !important;
    max-width: 91.46667vw;
    border-radius: 4.26667vw;
    .common-confirm-dialog-template {
      padding: 0;
    }
    .dialog-header {
      display: none;
    }
    .el-dialog__body {
      padding: 9.06667vw 4.26667vw 4.26667vw !important;
    }

    .dialog-body {
      .img {
        background-size: 100% 100%;
        margin: 0 auto;
        width: 60vw; /* 225px ÷ 3.75 */
        height: 60vw; /* 225px ÷ 3.75 */

        &.box {
          background: url('~assets/images/error/unpaid_box.png') no-repeat;
          background-size: 100% 100%;
          margin: -14.133vw auto 2.667vw; /* -53px ÷ 3.75 ≈ -14.133vw；10px ÷ 3.75 ≈ 2.667vw */
          width: 29.867vw; /* 112px ÷ 3.75 ≈ 29.867vw */
          height: 29.867vw; /* 112px ÷ 3.75 ≈ 29.867vw */
        }
      }

      .title {
        margin: 0 auto;
        width: 82.933vw; /* 311px ÷ 3.75 ≈ 82.933vw */
        text-align: center;
        font-size: 4.8vw; /* 20px ÷ 3.75 ≈ 5.333vw */
        line-height: 6.4vw; /* 24px ÷ 3.75 = 6.4vw */
        color: var(--txt-color-lv1);

        // &:nth-child(1) {
        //   margin-top: 6.4vw; /* 24px ÷ 3.75 = 6.4vw */
        // }
      }

      .title.custom-title {
        margin-top: 0;
      }

      .dialog-content-container {
        .content {
          margin: 2.667vw auto 6.4vw; /* 10px ÷ 3.75 ≈ 2.667vw */
          width: 82.933vw; /* 311px ÷ 3.75 ≈ 82.933vw */
          text-align: center;
          font-size: 3.7333vw; /* 16px ÷ 3.75 ≈ 4.267vw */
          line-height: 5.067vw; /* 19px ÷ 3.75 ≈ 5.067vw */
          color: var(--txt-color-lv2);
          &.is-triage-content {
            width: 100%;
            font-size: 5.333vw; /* 20px ÷ 3.75 ≈ 5.333vw */
            font-family: Roboto-Flex, sans-serif;
            font-weight: 600;
            color: #44454C;
            line-height: 7.467vw; /* 28px ÷ 3.75 ≈ 7.467vw */
            text-align: left;
            margin: 0;
          }
        }
      }
    }

    .dialog-footer {
      margin: 0;
      .button.button-normal {
        font-size: 4.26667vw;
      }
    }

    .custom-footer {
      margin: 8.533vw 0 0 0; /* 32px ÷ 3.75 ≈ 8.533vw */
    }
    .triage-btn {
      width: 53.333vw; /* 200px ÷ 3.75 ≈ 53.333vw */
      height: 15.467vw; /* 58px ÷ 3.75 ≈ 15.467vw */
      font-size: 5.333vw; /* 20px ÷ 3.75 ≈ 5.333vw */
      font-family: Roboto-Flex, sans-serif;
      font-weight: 600;
    }
  }
}
</style>
